<template>
  <div class="container flex">
    <div
      class="mx-auto flex flex-col gap-5 overflow-auto py-7.5 max-lg:w-full lg:flex-row lg:py-9"
    >
      <template v-for="(slide, idx) in props.data.slides" :key="slide.id">
        <div
          class="flex shrink-0 flex-col items-center border border-gray-30 px-6 py-9 pb-2.5 max-lg:hidden lg:w-[312px]"
        >
          <div class="mb-6 flex h-[65px] w-[130px] items-center">
            <UiLazyImg
              v-if="slide?.file?.url"
              :src="slide?.file?.url"
              :alt="slide?.title || slide?.file?.original_name"
            />
          </div>
          <div v-html="slide.text" />
        </div>
        <div
          class="flex flex-col items-center gap-10 border border-gray-30 px-8.5 py-5 lg:!hidden"
        >
          <button
            class="flex w-full items-center justify-between"
            type="button"
            :aria-label="$t('toggleActive')"
            @click="toggleActive(idx)"
          >
            <div class="flex h-[65px] w-[130px] items-center">
              <UiLazyImg
                v-if="slide?.file?.url"
                :src="slide?.file?.url"
                :alt="slide?.title || slide?.file?.original_name"
              />
            </div>
            <UiIcon
              class="h-6 w-6 text-primary"
              :name="activeItem !== idx ? 'chevron_down' : 'chevron_up'"
            />
          </button>
          <SharedCollapseTransition>
            <div
              v-show="activeItem === idx"
              @click="contentLink"
              v-html="slide.text"
            />
          </SharedCollapseTransition>
        </div>
      </template>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { BlockSliderContent } from "@/types/api/block.types";

const props = defineProps<{ data: BlockSliderContent }>();

const contentLink = useContentLink;

const activeItem = ref(-1);

function toggleActive(idx: number) {
  if (idx === activeItem.value) {
    activeItem.value = -1;
  } else {
    activeItem.value = idx;
  }
}
</script>
